
import Login from '../components/Auth/Login';

// Functional component that renders the Login component
function LoginPage() {
  return <Login />;
}

export default LoginPage;
